import {
  BookTwoTone,
  GroupTwoTone,
  HourglassBottom,
  MoneyTwoTone
} from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Typography
} from '@mui/material';

type CardProps = {
  count: number;
  title: string;
  onClick?: () => void;
  loading?: boolean;
};

export function UserCard({ ...props }: CardProps) {
  return <DashboardCard {...props} icon={GroupTwoTone} />;
}

export function BookCard({ ...props }: CardProps) {
  return <DashboardCard {...props} icon={BookTwoTone} />;
}

export function AmountCard({ count, title, onClick, loading }: CardProps) {
  return (
    <DashboardCard
      onClick={onClick}
      count={count}
      title={title}
      icon={MoneyTwoTone}
      loading={loading}
      md={4}
    />
  );
}

export function CountCard({ count, title, onClick }: CardProps) {
  return (
    <DashboardCard
      onClick={onClick}
      count={count}
      title={title}
      icon={HourglassBottom}
    />
  );
}

function DashboardCard({
  icon: Icon,
  title,
  count,
  onClick,
  loading,
  md = 3
}: CardProps & { icon: any; md?: number }) {
  return (
    <Grid
      onClick={onClick}
      style={{ cursor: 'pointer' }}
      xs={12}
      sm={6}
      md={md}
      item
    >
      {loading && (
        <Skeleton variant="rectangular" width={'100%'} height={140} />
      )}
      {!loading && (
        <Card sx={{ px: 1 }}>
          <CardContent>
            <Icon />
            <Typography variant="h5" noWrap>
              {title}
            </Typography>
            <Box sx={{ pt: 3 }}>
              <Typography variant="h3" gutterBottom noWrap>
                {count}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      )}
    </Grid>
  );
}
